module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("k6D68"))).then(() => parcelRequire('hEqeo'));